export default __webpack_public_path__ + "static/08_Goat-27c6c7063af8b768b59937b414dd9a94.png";